import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { InformationGetter } from '@/store/information/information.module';
import { Information } from '@/store/information/information.model';
import InformationFormComponent from '@/components/informationForm/InformationForm.vue';

export default defineComponent({
  name: 'VisionMissionPage',
  components: {
    InformationFormComponent
  },
  setup: () => {
    const store = useStore();
    const information = computed<Information>(() => store.getters[InformationGetter.GET]);
    const informationForm = ref<InstanceType<typeof InformationFormComponent>>();

    const editClick = () => {
      informationForm.value?.show();
    };

    return {
      information,
      informationForm,
      editClick,
    };
  }
});
